import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFaceFrown, faFaceMeh, faFaceSmile} from "@fortawesome/free-solid-svg-icons";

function FaceControl({face}: { face: string }) {
    if (face === "GOOD") return <span className={"text-success lh-2em"}><FontAwesomeIcon icon={faFaceSmile}
                                                                                         size={"xl"}/></span>;
    if (face === "NEUTRAL") return <span className={"text-secondary lh-2em"}><FontAwesomeIcon icon={faFaceMeh}
                                                                                              size={"xl"}/></span>;
    if (face === "BAD") return <span className={"text-danger lh-2em"}><FontAwesomeIcon icon={faFaceFrown} size={"xl"}/></span>;
    return null;
}

export default FaceControl;
